export const isProd = () => {
  const bartDomain = window.location.hostname;
  return bartDomain.startsWith("prod");
};
